import { Navigate, createBrowserRouter } from "react-router-dom";
import DefaultLayout from "./components/DefaultLayout";
import GuestLayout from "./components/GuestLayout";
import RequireAuth from "./hooks/RequireAuth";

// import Dashboard from "./views/dashboard/Dashboard";

import Login from "./views/auth/Login";
import Dashboard from "./views/dashboard/Dashboard";
import GestAdmins from "./views/gestion_administrateurs/GestAdmins";
import { GestClients } from "./views/gestion_clients/GestClients";
import GestPartenaires from "./views/gestion_partenaires/GestPartenaires";
import Profile from "./views/profile/Profil";
import EditProfile from "./views/profile/EditProfile";
import About from "./views/About";
import AddAdmin from "./views/gestion_administrateurs/AddAdmin";
import Entreprise from "./views/gestion_partenaires/Entreprise";
import RegisterDemande from "./views/gestion_demandes_inscription/RegisterDemande";
import { GestTickets } from "./views/gestion_tickets/GestTickets";
import GestCategory from "./views/gestion_categories/GestCategory";
import GestLocations from "./views/gestion_locations/GestLocations";
import TypeAbonnements from "./views/gestion_abonnements/TypeAbonnements";
import GestionContact from "./views/gestion_contact/GestionContact";
import EditAdmin from "./views/gestion_administrateurs/EditAdmin";
import GestEvents from "./views/gestion_evenements/GestEvents";
import AddEvent from "./views/gestion_evenements/AddEvent";
import AllEvents from "./views/gestion_evenements/AllEvents";
import EditEvent from "./views/gestion_evenements/EditEvent";
import ResetPassword from "./views/auth/ResetPassword";
import ResetPwdPage from "./views/auth/ResetPwdPage";
import GestNotifications from "./views/gestion_notifications/GestNotifications";
import Security from "./views/profile/Security";
import AddPartenaire from "./views/gestion_partenaires/AddPartenaire";
import EditPartenaire from "./views/gestion_partenaires/EditPartenaire";
import GestServices from "./views/gestion_services/GestServices";
import AddService from "./views/gestion_services/AddService";
import EditService from "./views/gestion_services/EditService";
import { useEffect, useState } from "react";
import GestPromotions from "./views/gestion_promotions/GestPromotions";
import GestPartenairesSignales from "./views/gestion_partenaires_signalés/GestPartenairesSignales";
import Unauthorized from "./views/Unauthorized";
import NotFound from "./views/NotFound";
import ContactUs from "./views/ContactUs";
import Rooms from "./views/chat_room/Rooms";
import AllRooms from "./views/chat_room/AllRooms";
import Birthday from "./views/birthday/Birthday";
import LandingPage from "./views/landing_page/LandingPage";
import Updates from "./views/gestion_updates/Updates";
import { Emails } from "./views/emails/Emails";


const MainComponent = () => {
  const [userRole, setUserRole] = useState(localStorage.getItem('role') || 'ADMIN');

  useEffect(() => {
    setUserRole(localStorage.getItem('role') || 'ADMIN');
  }, [localStorage.getItem('role')]);

  return (
    <RequireAuth
      element={
        userRole === 'RESPOEVENTS' ? <GestEvents /> : 
        userRole === 'AGENTSUPPORT' ? <GestTickets /> : 
        <Dashboard />
      }
      allowedRoles={['SUPERADMIN', 'ADMIN', 'MASTER', 'RESPO', 'RESPOEVENTS', 'AGENTSUPPORT']}
    />
  );
};
const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      {
        path: '/',
        element: <MainComponent />
      },
    
      // {
      //   path: '/',
      //   element:<RequireAuth element={<Dashboard/>}/>  
      // },
      {
        path: '/admins',
        element:<RequireAuth element={<GestAdmins/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/clients',
        element:<RequireAuth element={<GestClients/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/partenaires',
        element:<RequireAuth element={<GestPartenaires/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/ajouter-partenaire',
        element:<RequireAuth element={<AddPartenaire/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/entreprise',
        element:<RequireAuth element={<Entreprise/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/profil',
        element:<RequireAuth element={<Profile/>}/>  
      },
      {
        path: '/modifier-profil',
        element:<RequireAuth element={<EditProfile/>}/>  
      },
      {
        path: '/ajouter-admin',
        element:<RequireAuth element={<AddAdmin/>}allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/modifier-admin',
        element:<RequireAuth element={<EditAdmin/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/demandes-inscription',
        element:<RequireAuth element={<RegisterDemande/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/tickets',
        element:<RequireAuth element={<GestTickets/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'MASTER', 'RESPO', 'AGENTSUPPORT']} />  
      },
      {
        path: '/categories',
        element:<RequireAuth element={<GestCategory/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/localisations',
        element:<RequireAuth element={<GestLocations/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/aPropos',
        element:<RequireAuth element={<About/>}/>  
      },
      {
        path: '/types_abonnements',
        element:<RequireAuth element={<TypeAbonnements/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/contacts',
        element:<RequireAuth element={<GestionContact/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/evenements',
        element:<RequireAuth element={<GestEvents/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/ajouter-evenement',
        element:<RequireAuth element={<AddEvent/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/liste-evenements',
        element:<RequireAuth element={<AllEvents/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/modifier-evenement',
        element:<RequireAuth element={<EditEvent/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/notifications',
        element:<RequireAuth element={<GestNotifications/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: '/securite-de-compte',
        element:<RequireAuth element={<Security/>}/>  
      },
      {
        path: '/modifier-partenaire',
        element:<RequireAuth element={<EditPartenaire/>} allowedRoles={['SUPERADMIN', 'ADMIN', 'RESPO']}/>  
      },
      {
        path: '/apa-agency-services',
        element:<RequireAuth element={<GestServices/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: 'ajouter-service',
        element:<RequireAuth element={<AddService/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: 'modifier-service',
        element:<RequireAuth element={<EditService/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: 'apa-promotions',
        element:<RequireAuth element={<GestPromotions/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: 'partenaires-signales',
        element:<RequireAuth element={<GestPartenairesSignales/> } allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      // {
      //   path: 'partenaires-clients-chat',
      //   element:<RequireAuth element={<Chat/>}/>  
      // },
      {
        path: 'chat',
        element:<RequireAuth element={<Rooms/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: 'rooms',
        element:<RequireAuth element={<AllRooms/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: 'birthdays',
        element:<RequireAuth element={<Birthday/>} />  
      },
      {
        path: 'updates',
        element:<RequireAuth element={<Updates/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      {
        path: 'emails',
        element:<RequireAuth element={<Emails/>} allowedRoles={['SUPERADMIN', 'ADMIN']}/>  
      },
      
     
    ]
  },
  {
    path: '/',
    element: <GuestLayout />,
    children: [
      {
        path: '/login',
        element: <Login />
      },
      {
        path: "/unauthorized",
        element: <Unauthorized />
      },
      {
        path: '/reset_password',
        element: <ResetPassword />
      },
      {
        path: '/reinitialisation_de_motdepasse/:userId/:token/:expires',
        element: <ResetPwdPage />
      },
      {
        path: '/Contactez-nous',
        element: <ContactUs />
      },

      
    ]
  },

  {
    path: "*",
    element: <NotFound />
  }
])

export default router;
